import React, { Component } from 'react'
import { connect } from 'react-redux'
import './styles.css'

import PageWrapper from '../../components/PageWrapper'
import WhiteBox from '../../components/WhiteBox'
import ReactTooltip from 'react-tooltip'
import Sidebar from 'react-sidebar'
import DocDrawer from './drawer'

class Documentation extends Component {
    state = {
        phase: 0,
        userAttributes: null,
        errorMessage: null,
        username: null,
        cognitoUser: null,
        disabled: true,
        changePasswordDisabled: true
    }

    render() {
        const sidebar = <DocDrawer />

        const sidebarProps = {
            sidebar: sidebar,
            docked: true,
            open: true,
            onSetOpen: null
        }

        let marginTopParagraph = '40px'

        return (
            <Sidebar {...sidebarProps}>
                <div className="">
                    <div className="doc-page" style={{ 'margin-bottom': '100px', 'text-align': 'left', padding: '20px', background: '#f1f2f7' }}>
                        <WhiteBox>
                            <div className="row" id="doc_integrations">
                                <div className="col">
                                    <h2 style={{ 'border-bottom': '1px solid lightgray', 'margin-bottom': '20px' }} className="">
                                        Features
                                    </h2>
                                    <p>
                                        Audiencerate's platform features:
                                        <ul>
                                            <li>
                                                Creating audiences, listing, editing and removing them, <b>daily reporting of segment sizes</b>
                                            </li>
                                            <li>Uploading data segments and associate them to audiences</li>
                                            <li>Track Audience upload status and performance on the target platform</li>
                                            <li>Licensing audiences to platforms, activate and deactivate them, set an expiration and a minimum cpm price</li>
                                            <li>Track all user interaction to an Audience or Licenses</li>
                                            <li>See the revenues generated for each audience, updated daily</li>
                                        </ul>
                                    </p>

                                    <h3 style={{ marginTop: marginTopParagraph }} className="">
                                        Benefits
                                    </h3>
                                    <p>
                                        Audiencerate platform has those benefits from other competitors:
                                        <ul>
                                            <li>
                                                Audience uploads in <b>1-3 days</b> (not 3 weeks)
                                            </li>
                                            <li>
                                                <b>Revenue Reporting</b> updated every 8 hours 3 times a day, so you can understand revenues, pace of revenues
                                                and yield
                                            </li>
                                            <li>
                                                Audience size count from <b>today to 30 days before</b> updated every day.
                                            </li>
                                            <li>
                                                <b>Direct access to all of Google’s universe</b>
                                            </li>
                                            <li>
                                                <b>Controls</b> over pricing, distribution, segment start/expiration
                                            </li>
                                            <li>
                                                <b>Higher margins</b> form competitors
                                            </li>
                                            <li>
                                                <b>No monthly minimums</b>
                                            </li>
                                            <li>
                                                <b>Reseller program</b> features
                                            </li>
                                            <li>
                                                <b>International Market</b>: we can sell in all the world!
                                            </li>
                                        </ul>
                                    </p>
                                </div>
                            </div>
                        </WhiteBox>
                    </div>
                </div>
            </Sidebar>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(Documentation)
